import { createAsyncThunk, createSlice } from "@reduxjs/toolkit";
import axios from "axios";
import useMerchantPortalAxios from "../utils/axios";
import { config } from "../utils/Constants";

const URL = config.url;

const initialState = {
    allCurrencies: [],
    loading: false,
    error: null
};


export const getAllCurrencies = createAsyncThunk(
    "statementOfAccount/getAllCurrencies",
    async (_, { rejectWithValue }) => {
        try {
            const res = await axios.get(URL + "/v1/CommonData/GetAllCurrencies");
            const currencies = res.data.Currencies;
            sessionStorage.setItem("Currencies", JSON.stringify(currencies));
            return currencies;
        } catch (error) {
            return rejectWithValue(error.response.data);
        }
    }
);

const statementOfAccountSlice = createSlice({
    name: "statementOfAccount",
    initialState,
    reducers: {
        setAllCurrencies: (state, action) => {
            state.allCurrencies = action.payload;
        }
    },
    extraReducers: (builder) => {
        builder
            .addCase(getAllCurrencies.pending, (state) => {
                state.loading = true;
                state.error = null;
            })
            .addCase(getAllCurrencies.fulfilled, (state, action) => {
                state.allCurrencies = action.payload;
                state.loading = false;
            })
            .addCase(getAllCurrencies.rejected, (state, action) => {
                state.loading = false;
                state.error = action.payload;
            });
    }
});

export const { setAllCurrencies } = statementOfAccountSlice.actions;
export default statementOfAccountSlice.reducer;
